import { render, staticRenderFns } from "./TgRelateGame.vue?vue&type=template&id=0b6203e8&"
import script from "./TgRelateGame.vue?vue&type=script&lang=js&"
export * from "./TgRelateGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports